import { render } from "./PromptAddData.vue?vue&type=template&id=0261d4dc"
import script from "./PromptAddData.vue?vue&type=script&lang=js"
export * from "./PromptAddData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__